export interface Region {
  sido: string;
  sigungu: string;
  emd: string;
}
export interface RegionProps {
  code: string;
  region: string;
}

export interface FilterType {
  type: string;
  year?: string;
  caseNumber: string;
  radio: string;
  region: Region[];
  court: string;
  belong?: string | undefined;
  address: string;
  expectItemStatus?: string;
  itemStatus: string[];
  multiItemStatus: string[];
  appraisalPrice: { min: string; max: string };
  approvalDate: { start: string; end: string };
  minPrice: { min: string; max: string };
  saleDate: { start: string; end: string };
  buildingArea: { min: string; max: string };
  landArea: { min: string; max: string };
  bidStatus: string;
  progressStatus: string;
  disposalMethod: string;
  specialItemCond: string;
  holdingCompany: string[];
  specialItemCondition: string[];
  useArea: string[];
  asset1: string[];
  asset2: string[];
  group?: string;
  level?: string;
  auctionProcedure?: string;
  holder?: string;
  debtor?: string;
  creditor?: string;
}

export interface MapFilterType {
  itemTab: string;
  multiItemStatus: string[];
  specialItemCondition: string[];
  specialItemCond: string;
  search: string;
  progressStatus: string[];
}

export const generateYearList = () => {
  const startYear = 1995;
  const currentYear = new Date().getFullYear();

  return Array.from({ length: currentYear - startYear + 1 }, (_, index) => {
    const year = startYear + index;
    return {
      value: String(year),
      label: String(year),
    };
  }).reverse();
};

export const SystemList = [
  { value: '1계', label: '1계' },
  { value: '2계', label: '2계' },
  { value: '3계', label: '3계' },
  { value: '4계', label: '4계' },
  { value: '5계', label: '5계' },
  { value: '6계', label: '6계' },
  { value: '7계', label: '7계' },
  { value: '8계', label: '8계' },
  { value: '9계', label: '9계' },
  { value: '10계', label: '10계' },
  { value: '11계', label: '11계' },
  { value: '12계', label: '12계' },
  { value: '13계', label: '13계' },
  { value: '14계', label: '14계' },
  { value: '15계', label: '15계' },
  { value: '16계', label: '16계' },
  { value: '17계', label: '17계' },
  { value: '18계', label: '18계' },
  { value: '19계', label: '19계' },
  { value: '20계', label: '20계' },
  { value: '21계', label: '21계' },
  { value: '22계', label: '22계' },
  { value: '23계', label: '23계' },
  { value: '24계', label: '24계' },
  { value: '25계', label: '25계' },
  { value: '26계', label: '26계' },
  { value: '27계', label: '27계' },
  { value: '28계', label: '28계' },
  { value: '29계', label: '29계' },
  { value: '30계', label: '30계' },
  { value: '31계', label: '31계' },
  { value: '32계', label: '32계' },
  { value: '33계', label: '33계' },
  { value: '34계', label: '34계' },
  { value: '35계', label: '35계' },
  { value: '기타', label: '기타' },
];

export const SidoList = [
  { code: '11', region: '서울' },
  { code: '41', region: '경기' },
  { code: '28', region: '인천' },
  { code: '26', region: '부산' },
  { code: '30', region: '대전' },
  { code: '27', region: '대구' },
  { code: '31', region: '울산' },
  { code: '36', region: '세종' },
  { code: '42', region: '강원' },
  { code: '43', region: '충북' },
  { code: '44', region: '충남' },
  { code: '47', region: '경북' },
  { code: '48', region: '경남' },
  { code: '29', region: '광주' },
  { code: '45', region: '전북' },
  { code: '46', region: '전남' },
  { code: '50', region: '제주' },
];

export const CourtList = [
  {
    value: '서울중앙지방법원  본원',
    label: '서울중앙지방법원  본원',
  },
  {
    value: '서울동부지방법원  본원',
    label: '서울동부지방법원  본원',
  },
  {
    value: '서울서부지방법원  본원',
    label: '서울서부지방법원  본원',
  },
  {
    value: '서울남부지방법원  본원',
    label: '서울남부지방법원  본원',
  },
  {
    value: '서울북부지방법원  본원',
    label: '서울북부지방법원  본원',
  },
  {
    value: '의정부지방법원  본원',
    label: '의정부지방법원  본원',
  },
  {
    value: '의정부지방법원  고양지원',
    label: '의정부지방법원  고양지원',
  },
  {
    value: '의정부지방법원  남양주지원',
    label: '의정부지방법원  남양주지원',
  },
  {
    value: '인천지방법원  본원',
    label: '인천지방법원  본원',
  },
  {
    value: '인천지방법원  부천지원',
    label: '인천지방법원  부천지원',
  },
  {
    value: '수원지방법원  본원',
    label: '수원지방법원  본원',
  },
  {
    value: '수원지방법원  성남지원',
    label: '수원지방법원  성남지원',
  },
  {
    value: '수원지방법원  여주지원',
    label: '수원지방법원  여주지원',
  },
  {
    value: '수원지방법원  평택지원',
    label: '수원지방법원  평택지원',
  },
  {
    value: '수원지방법원  안산지원',
    label: '수원지방법원  안산지원',
  },
  {
    value: '수원지방법원  안양지원',
    label: '수원지방법원  안양지원',
  },
  {
    value: '춘천지방법원  본원',
    label: '춘천지방법원  본원',
  },
  {
    value: '춘천지방법원  강릉지원',
    label: '춘천지방법원  강릉지원',
  },
  {
    value: '춘천지방법원  원주지원',
    label: '춘천지방법원  원주지원',
  },
  {
    value: '춘천지방법원  속초지원',
    label: '춘천지방법원  속초지원',
  },
  {
    value: '춘천지방법원  영월지원',
    label: '춘천지방법원  영월지원',
  },
  {
    value: '청주지방법원  본원',
    label: '청주지방법원  본원',
  },
  {
    value: '청주지방법원  충주지원',
    label: '청주지방법원  충주지원',
  },
  {
    value: '청주지방법원  제천지원',
    label: '청주지방법원  제천지원',
  },
  {
    value: '청주지방법원  영동지원',
    label: '청주지방법원  영동지원',
  },
  {
    value: '대전지방법원  본원',
    label: '대전지방법원  본원',
  },
  {
    value: '대전지방법원  홍성지원',
    label: '대전지방법원  홍성지원',
  },
  {
    value: '대전지방법원  논산지원',
    label: '대전지방법원  논산지원',
  },
  {
    value: '대전지방법원  천안지원',
    label: '대전지방법원  천안지원',
  },
  {
    value: '대전지방법원  공주지원',
    label: '대전지방법원  공주지원',
  },
  {
    value: '대전지방법원  서산지원',
    label: '대전지방법원  서산지원',
  },
  {
    value: '대구지방법원  본원',
    label: '대구지방법원  본원',
  },
  {
    value: '대구지방법원  서부지원',
    label: '대구지방법원  서부지원',
  },
  {
    value: '대구지방법원  안동지원',
    label: '대구지방법원  안동지원',
  },
  {
    value: '대구지방법원  경주지원',
    label: '대구지방법원  경주지원',
  },
  {
    value: '대구지방법원  김천지원',
    label: '대구지방법원  김천지원',
  },
  {
    value: '대구지방법원  상주지원',
    label: '대구지방법원  상주지원',
  },
  {
    value: '대구지방법원  의성지원',
    label: '대구지방법원  의성지원',
  },
  {
    value: '대구지방법원  영덕지원',
    label: '대구지방법원  영덕지원',
  },
  {
    value: '대구지방법원  포항지원',
    label: '대구지방법원  포항지원',
  },
  {
    value: '부산지방법원  본원',
    label: '부산지방법원  본원',
  },
  {
    value: '부산지방법원  동부지원',
    label: '부산지방법원  동부지원',
  },
  {
    value: '부산지방법원  서부지원',
    label: '부산지방법원  서부지원',
  },
  {
    value: '울산지방법원  본원',
    label: '울산지방법원  본원',
  },
  {
    value: '창원지방법원  본원',
    label: '창원지방법원  본원',
  },
  {
    value: '창원지방법원  마산지원',
    label: '창원지방법원  마산지원',
  },
  {
    value: '창원지방법원  진주지원',
    label: '창원지방법원  진주지원',
  },
  {
    value: '창원지방법원  통영지원',
    label: '창원지방법원  통영지원',
  },
  {
    value: '창원지방법원  밀양지원',
    label: '창원지방법원  밀양지원',
  },
  {
    value: '창원지방법원  거창지원',
    label: '창원지방법원  거창지원',
  },
  {
    value: '광주지방법원  본원',
    label: '광주지방법원  본원',
  },
  {
    value: '광주지방법원  목포지원',
    label: '광주지방법원  목포지원',
  },
  {
    value: '광주지방법원  장흥지원',
    label: '광주지방법원  장흥지원',
  },
  {
    value: '광주지방법원  순천지원',
    label: '광주지방법원  순천지원',
  },
  {
    value: '광주지방법원  해남지원',
    label: '광주지방법원  해남지원',
  },
  {
    value: '전주지방법원  본원',
    label: '전주지방법원  본원',
  },
  {
    value: '전주지방법원  군산지원',
    label: '전주지방법원  군산지원',
  },
  {
    value: '전주지방법원  정읍지원',
    label: '전주지방법원  정읍지원',
  },
  {
    value: '전주지방법원  남원지원',
    label: '전주지방법원  남원지원',
  },
  {
    value: '제주지방법원  본원',
    label: '제주지방법원  본원',
  },
];

export const ItemStatusList = [
  {
    label: '전체',
    options: [{ value: '전체', label: '전체' }],
  },
  {
    label: '주거용',
    options: [
      { value: '주거용전체', label: '주거용전체' },
      { value: '아파트', label: '아파트' },
      { value: '단독/연립', label: '단독/연립' },
      { value: '다가구/원룸', label: '다가구/원룸' },
      { value: '다세대/빌라', label: '다세대/빌라' },
      { value: '근린/상가주택', label: '근린/상가주택' },
      { value: '오피스텔', label: '오피스텔' },
    ],
  },
  {
    label: '상업/산업용',
    options: [
      { value: '상업/산업용전체', label: '상업/산업용전체' },
      { value: '근린생활시설', label: '근린생활시설' },
      { value: '사무실', label: '사무실' },
      { value: '지식산업센터', label: '지식산업센터' },
      { value: '창고', label: '창고' },
      { value: '공장', label: '공장' },
      { value: '숙박시설', label: '숙박시설' },
      { value: '숙박(콘도등)', label: '숙박(콘도등)' },
      { value: '목욕탕', label: '목욕탕' },
      { value: '노유자시설', label: '노유자시설' },
      { value: '문화 및 집회시설', label: '문화 및 집회시설' },
      { value: '종교시설', label: '종교시설' },
      { value: '의료시설', label: '의료시설' },
      { value: '교육연구시설', label: '교육연구시설' },
      { value: '장례관련시설', label: '장례관련시설' },
      { value: '농가관련시설', label: '농가관련시설' },
      { value: '주유소', label: '주유소' },
      { value: '자동차관련시설', label: '자동차관련시설' },
      { value: '분뇨 및  쓰레기처리', label: '분뇨 및  쓰레기처리' },
    ],
  },
  {
    label: '토지',
    options: [
      { value: '토지전체', label: '토지전체' },
      { value: '대지', label: '대지' },
      { value: '농지(전답)', label: '농지(전답)' },
      { value: '과수원', label: '과수원' },
      { value: '임야', label: '임야' },
      { value: '잡종지', label: '잡종지' },
      { value: '도로', label: '도로' },
      { value: '주차장', label: '주차장' },
      { value: '묘지', label: '묘지' },
      { value: '목장용지', label: '목장용지' },
      { value: '공장용지', label: '공장용지' },
      { value: '창고용지', label: '창고용지' },
      { value: '기타용지', label: '기타용지' },
    ],
  },
  {
    label: '기타',
    options: [{ value: '기타', label: '기타' }],
  },
];
export const PTypeItemStatusList = [
  {
    label: '전체',
    options: [{ value: '전체', label: '전체' }],
  },
  {
    label: '토지',
    options: [
      { value: '토지전체', label: '토지전체' },
      { value: '대지', label: '대지' },
      { value: '임야', label: '임야' },
      { value: '전', label: '전' },
      { value: '답', label: '답' },
      { value: '과수원', label: '과수원' },
      { value: '잡종지', label: '잡종지' },
      { value: '학교용지', label: '학교용지' },
      { value: '체육용지', label: '체육용지' },
      { value: '종교용지', label: '종교용지' },
      { value: '목장용지', label: '목장용지' },
      { value: '창고용지', label: '창고용지' },
      { value: '철도용지', label: '철도용지' },
      { value: '공장용지', label: '공장용지' },
      { value: '주유소용지', label: '주유소용지' },
      { value: '수도용지', label: '수도용지' },
      { value: '주차장', label: '주차장' },
      { value: '유원지', label: '유원지' },
      { value: '공원', label: '공원' },
      { value: '도로', label: '도로' },
      { value: '구거', label: '구거' },
      { value: '유지', label: '유지' },
      { value: '제방', label: '제방' },
      { value: '염전', label: '염전' },
      { value: '광천지', label: '광천지' },
      { value: '하천', label: '하천' },
      { value: '양어장', label: '양어장' },
      { value: '사적지', label: '사적지' },
      { value: '묘지', label: '묘지' },
      { value: '기타토지', label: '기타토지' },
      { value: '초지', label: '초지' },
      { value: '주택부지', label: '주택부지' },
      { value: '토지', label: '토지' },
      { value: '특수용지', label: '특수용지' },
    ],
  },
  {
    label: '주거용 건물',
    options: [
      { value: '주거용건물전체', label: '주거용건물전체' },
      { value: '아파트', label: '아파트' },
      { value: '주상복합', label: '주상복합' },
      { value: '빌라', label: '빌라' },
      { value: '단독주택', label: '단독주택' },
      { value: '다가구주택', label: '다가구주택' },
      { value: '다세대주택', label: '다세대주택' },
      { value: '다중주택', label: '다중주택' },
      { value: '도시형생활주택', label: '도시형생활주택' },
      { value: '연립주택', label: '연립주택' },
      { value: '전원주택', label: '전원주택' },
      { value: '기숙사', label: '기숙사' },
      { value: '사택', label: '사택' },
      { value: '공관', label: '공관' },
      { value: '상가주택', label: '상가주택' },
      { value: '이동식주택', label: '이동식주택' },
      { value: '조립식주택', label: '조립식주택' },
      { value: '컨테이너주택', label: '컨테이너주택' },
      { value: '기타주거용건물', label: '기타주거용건물' },
    ],
  },
  {
    label: '상가용및업무용',
    options: [
      { value: '상가용및업무용전체', label: '상가용및업무용전체' },
      { value: '근린생활시설', label: '근린생활시설' },
      { value: '문화및집회시설', label: '문화및집회시설' },
      { value: '종교시설', label: '종교시설' },
      { value: '판매시설', label: '판매시설' },
      { value: '운수시설', label: '운수시설' },
      { value: '의료시설', label: '의료시설' },
      { value: '교육연구시설', label: '교육연구시설' },
      { value: '노유자시설', label: '노유자시설' },
      { value: '수련시설', label: '수련시설' },
      { value: '운동시설', label: '운동시설' },
      { value: '업무시설', label: '업무시설' },
      { value: '숙박시설', label: '숙박시설' },
      { value: '위락시설', label: '위락시설' },
      { value: '교정및군사시설', label: '교정및군사시설' },
      { value: '방송및통신시설', label: '방송및통신시설' },
      { value: '발전시설', label: '발전시설' },
      { value: '묘지관련시설', label: '묘지관련시설' },
      { value: '관광휴게시설', label: '관광휴게시설' },
      { value: '공공용시설', label: '공공용시설' },
      { value: '부속건축물', label: '부속건축물' },
      { value: '무허가건축물', label: '무허가건축물' },
      { value: '가설건축물', label: '가설건축물' },
      { value: '기타상가용및업무용', label: '기타상가용및업무용' },
      { value: '골프장', label: '골프장' },
      { value: '스키장', label: '스키장' },
      { value: '기타근린생활시설', label: '기타근린생활시설' },
      { value: '공장및주택', label: '공장및주택' },
      { value: '기타건물', label: '기타건물' },
      { value: '모텔', label: '모텔' },
      { value: '여인숙', label: '여인숙' },
      { value: '콘도미니움', label: '콘도미니움' },
      { value: '호텔', label: '호텔' },
      { value: '사무실', label: '사무실' },
      { value: '사옥', label: '사옥' },
      { value: '기타의료용건물', label: '기타의료용건물' },
      { value: '요양소', label: '요양소' },
      { value: '구매시설', label: '구매시설' },
      { value: '백화점', label: '백화점' },
      { value: '상업용빌딩', label: '상업용빌딩' },
      { value: '시장', label: '시장' },
    ],
  },
  {
    label: '산업용및기타특수용건물',
    options: [
      {
        value: '산업용및기타특수용건물전체',
        label: '산업용및기타특수용건물전체',
      },
      { value: '공장시설', label: '공장시설' },
      { value: '창고시설', label: '창고시설' },
      { value: '위험물저장및처리시설', label: '위험물저장및처리시설' },
      { value: '자동차관련시설', label: '자동차관련시설' },
      { value: '동물및식물관련시설', label: '동물및식물관련시설' },
      { value: '분뇨및쓰레기처리시설', label: '분뇨및쓰레기처리시설' },
      { value: '해양처리폐기물 저장시설', label: '해양처리폐기물 저장시설' },
      { value: '가스 저장소', label: '가스 저장소' },
      { value: '기타제조공장', label: '기타제조공장' },
      { value: '사무기기공장', label: '사무기기공장' },
      { value: '자동차부품공장', label: '자동차부품공장' },
      { value: '전자공장', label: '전자공장' },
      { value: '철강공장', label: '철강공장' },
      { value: '통신기기공장', label: '통신기기공장' },
      { value: '주유소', label: '주유소' },
    ],
  },
  {
    label: '용도복합용건물',
    options: [
      {
        value: '용도복합용건물전체',
        label: '용도복합용건물전체',
      },
      { value: '주/상용건물', label: '주/상용건물' },
      { value: '주·산용건물', label: '주·산용건물' },
      { value: '오피스텔', label: '오피스텔' },
      { value: '기타용도복합건물', label: '기타용도복합건물' },
    ],
  },
];

export const BidStatusList = [
  {
    value: '',
    label: '전체',
  },
  {
    value: '0',
    label: '신건(유찰 0회)',
  },
  {
    value: '1',
    label: '유찰 1회 이상',
  },
  {
    value: '2',
    label: '유찰 2회 이상',
  },
  {
    value: '3',
    label: '유찰 3회 이상',
  },
  {
    value: '4',
    label: '유찰 4회 이상',
  },
  {
    value: '5',
    label: '유찰 5회 이상',
  },
];

export const ProgressStatusList = [
  {
    label: '전체',
    options: [{ value: '전체', label: '전체' }],
  },
  {
    label: '진행물건',
    options: [
      { value: '진행', label: '진행' },
      { value: '신건', label: '신건' },
      { value: '유찰', label: '유찰' },
    ],
  },
  {
    label: '매각전부',
    options: [
      { value: '매각/매각허가', label: '매각/매각허가' },
      { value: '잔금납부물건', label: '잔금납부물건' },
      { value: '배당기일/종결', label: '배당기일/종결' },
    ],
  },
  {
    label: '진행외물건',
    options: [
      { value: '미진행', label: '미진행' },
      { value: '변경/연기', label: '변경/연기' },
      { value: '불허가/허가취소', label: '불허가/허가취소' },
      { value: '정지', label: '정지' },
    ],
  },
  {
    label: '종국물건',
    options: [
      { value: '각하', label: '각하' },
      { value: '기각', label: '기각' },
      { value: '기타', label: '기타' },
      { value: '이송', label: '이송' },
      { value: '취소', label: '취소' },
    ],
  },
];
export const PTypeProgressStatusList = [
  { value: '', label: '전체' },
  { value: '예정', label: '예정' },
  { value: '진행', label: '진행' },
  // { value: '신건', label: '신건' },
  // { value: '유찰', label: '유찰' },
  { value: '낙찰', label: '낙찰' },
  { value: '취소', label: '취소' },
];

export const DisposalMethodList = [
  { value: '매각', label: '매각' },
  // { value: '전체', label: '전체' },
  // { value: '임대(대부)', label: '임대(대부)' },
];

export const MainCategory = [
  { name: '전체', value: 'all' },
  { name: '주거용', value: 'residential' },
  { name: '상업/산업용', value: 'commercial' },
  { name: '토지', value: 'land' },
  { name: '기타', value: 'etc' },
];
export const AllSubCategory = [{ name: '전체', value: '전체' }];

export const ResidentialSubCategory = [
  { name: '아파트', value: '아파트' },
  { name: '단독/연립', value: '단독/연립' },
  { name: '다가구/원룸', value: '다가구/원룸' },
  { name: '다세대/빌라', value: '다세대/빌라' },
  { name: '근린/상가주택', value: '근린/상가주택' },
  { name: '오피스텔', value: '오피스텔' },
];
export const CommercialSubCategory = [
  { name: '근린생활시설', value: '근린생활시설' },
  { name: '사무실', value: '사무실' },
  { name: '지식산업센터', value: '지식산업센터' },
  { name: '창고', value: '창고' },
  { name: '공장', value: '공장' },
  { name: '숙박시설', value: '숙박시설' },
  { name: '숙박(콘도등)', value: '숙박(콘도등)' },
  { name: '목욕탕', value: '목욕탕' },
  { name: '노유자시설', value: '노유자시설' },
  { name: '문화 및 집회시설', value: '문화 및 집회시설' },
  { name: '종교시설', value: '종교시설' },
  { name: '의료시설', value: '의료시설' },
  { name: '교육연구시설', value: '교육연구시설' },
  { name: '장례관련시설', value: '장례관련시설' },
  { name: '농가관련시설', value: '농가관련시설' },
  { name: '주유소', value: '주유소' },
  { name: '자동차관련시설', value: '자동차관련시설' },
  { name: '분뇨 및  쓰레기처리', value: '분뇨 및  쓰레기처리' },
];
export const LandSubCategory = [
  { name: '대지', value: '대지' },
  { name: '농지(전답)', value: '농지(전답)' },
  { name: '과수원', value: '과수원' },
  { name: '임야', value: '임야' },
  { name: '잡종지', value: '잡종지' },
  { name: '도로', value: '도로' },
  { name: '주차장', value: '주차장' },
  { name: '묘지', value: '묘지' },
  { name: '목장용지', value: '목장용지' },
  { name: '공장용지', value: '공장용지' },
  { name: '창고용지', value: '창고용지' },
  { name: '기타용지', value: '기타용지' },
];
export const EtcSubCategory = [{ name: '기타', value: '기타' }];

export const PtypeMainCategory = [
  {
    name: '전체',
    value: '전체',
  },
  {
    name: '토지',
    value: '토지',
  },
  {
    name: '주거용건물',
    value: '주거용건물',
  },
  {
    name: '상가용및업무용건물',
    value: '상가용및업무용건물',
  },
  {
    name: '산업용및기타특수용건물',
    value: '산업용및기타특수용건물',
  },
  {
    name: '용도복합용건물',
    value: '용도복합용건물',
  },
];

export const PTypeLandCategoty = [
  { name: '대지', value: '대지' },
  { name: '임야', value: '임야' },
  { name: '전', value: '전' },
  { name: '답', value: '답' },
  { name: '과수원', value: '과수원' },
  { name: '잡종지', value: '잡종지' },
  { name: '학교용지', value: '학교용지' },
  { name: '체육용지', value: '체육용지' },
  { name: '종교용지', value: '종교용지' },
  { name: '목장용지', value: '목장용지' },
  { name: '창고용지', value: '창고용지' },
  { name: '철도용지', value: '철도용지' },
  { name: '공장용지', value: '공장용지' },
  { name: '주유소용지', value: '주유소용지' },
  { name: '수도용지', value: '수도용지' },
  { name: '주차장', value: '주차장' },
  { name: '유원지', value: '유원지' },
  { name: '공원', value: '공원' },
  { name: '도로', value: '도로' },
  { name: '구거', value: '구거' },
  { name: '유지', value: '유지' },
  { name: '제방', value: '제방' },
  { name: '염전', value: '염전' },
  { name: '광천지', value: '광천지' },
  { name: '하천', value: '하천' },
  { name: '양어장', value: '양어장' },
  { name: '사적지', value: '사적지' },
  { name: '묘지', value: '묘지' },
  { name: '기타토지', value: '기타토지' },
  { name: '초지', value: '초지' },
  { name: '주택부지', value: '주택부지' },
  { name: '토지', value: '토지' },
  { name: '특수용지', value: '특수용지' },
];

export const PTypeResidentialCategory = [
  { name: '아파트', value: '아파트' },
  { name: '주상복합', value: '주상복합' },
  { name: '빌라', value: '빌라' },
  { name: '단독주택', value: '단독주택' },
  { name: '다가구주택', value: '다가구주택' },
  { name: '다세대주택', value: '다세대주택' },
  { name: '다중주택', value: '다중주택' },
  { name: '도시형생활주택', value: '도시형생활주택' },
  { name: '연립주택', value: '연립주택' },
  { name: '전원주택', value: '전원주택' },
  { name: '기숙사', value: '기숙사' },
  { name: '사택', value: '사택' },
  { name: '공관', value: '공관' },
  { name: '상가주택', value: '상가주택' },
  { name: '이동식주택', value: '이동식주택' },
  { name: '조립식주택', value: '조립식주택' },
  { name: '컨테이너주택', value: '컨테이너주택' },
  { name: '기타주거용건물', value: '기타주거용건물' },
];
export const PTypeCommercialCategory = [
  { name: '근린생활시설', value: '근린생활시설' },
  { name: '문화및집회시설', value: '문화및집회시설' },
  { name: '종교시설', value: '종교시설' },
  { name: '판매시설', value: '판매시설' },
  { name: '운수시설', value: '운수시설' },
  { name: '의료시설', value: '의료시설' },
  { name: '교육연구시설', value: '교육연구시설' },
  { name: '노유자시설', value: '노유자시설' },
  { name: '수련시설', value: '수련시설' },
  { name: '운동시설', value: '운동시설' },
  { name: '업무시설', value: '업무시설' },
  { name: '숙박시설', value: '숙박시설' },
  { name: '위락시설', value: '위락시설' },
  { name: '교정및군사시설', value: '교정및군사시설' },
  { name: '방송및통신시설', value: '방송및통신시설' },
  { name: '발전시설', value: '발전시설' },
  { name: '묘지관련시설', value: '묘지관련시설' },
  { name: '관광휴게시설', value: '관광휴게시설' },
  { name: '공공용시설', value: '공공용시설' },
  { name: '부속건축물', value: '부속건축물' },
  { name: '무허가건축물', value: '무허가건축물' },
  { name: '가설건축물', value: '가설건축물' },
  { name: '기타상가용및업무용', value: '기타상가용및업무용' },
  { name: '골프장', value: '골프장' },
  { name: '스키장', value: '스키장' },
  { name: '기타근린생활시설', value: '기타근린생활시설' },
  { name: '공장및주택', value: '공장및주택' },
  { name: '기타건물', value: '기타건물' },
  { name: '모텔', value: '모텔' },
  { name: '여인숙', value: '여인숙' },
  { name: '콘도미니움', value: '콘도미니움' },
  { name: '호텔', value: '호텔' },
  { name: '사무실', value: '사무실' },
  { name: '사옥', value: '사옥' },
  { name: '기타의료용건물', value: '기타의료용건물' },
  { name: '요양소', value: '요양소' },
  { name: '구매시설', value: '구매시설' },
  { name: '백화점', value: '백화점' },
  { name: '상업용빌딩', value: '상업용빌딩' },
  { name: '시장', value: '시장' },
];

export const PTypeIndustrialCategory = [
  { name: '공장시설', value: '공장시설' },
  { name: '창고시설', value: '창고시설' },
  { name: '위험물저장및처리시설', value: '위험물저장및처리시설' },
  { name: '자동차관련시설', value: '자동차관련시설' },
  { name: '동물및식물관련시설', value: '동물및식물관련시설' },
  { name: '분뇨및쓰레기처리시설', value: '분뇨및쓰레기처리시설' },
  { name: '해양처리폐기물 저장시설', value: '해양처리폐기물 저장시설' },
  { name: '가스 저장소', value: '가스 저장소' },
  { name: '기타제조공장', value: '기타제조공장' },
  { name: '사무기기공장', value: '사무기기공장' },
  { name: '자동차부품공장', value: '자동차부품공장' },
  { name: '전자공장', value: '전자공장' },
  { name: '철강공장', value: '철강공장' },
  { name: '통신기기공장', value: '통신기기공장' },
  { name: '주유소', value: '주유소' },
];

export const PTypeComplexCategory = [
  { name: '주/상용건물', value: '주/상용건물' },
  { name: '주·산용건물', value: '주·산용건물' },
  { name: '오피스텔', value: '오피스텔' },
  { name: '기타용도복합건물', value: '기타용도복합건물' },
];

export const ItemStatusData = [
  { name: '오늘 공고된 신건', value: '오늘 공고된 신건' },
  { name: '재매각 물건', value: '재매각 물건' },
  { name: '재진행 물건', value: '재진행 물건' },
  { name: '감정시점 1년 경과 물건', value: '감정시점 1년 경과 물건' },
  { name: '위반 건축물', value: '위반 건축물' },
  { name: '맹지', value: '맹지' },
  { name: '토지건물 일괄매각', value: '토지건물 일괄매각' },
  { name: '토지만 입찰 물건', value: '토지만 입찰 물건' },
  { name: '토지별도등기 있는 물건', value: '토지별도등기 있는 물건' },
  { name: '토지별도등기 인수조건', value: '토지별도등기 인수조건' },
  { name: '건물만 입찰 물건', value: '건물만 입찰 물건' },
  { name: '대지권미등기', value: '대지권미등기' },
  { name: '농지취득자격증명', value: '농지취득자격증명' },
  { name: '임금채권', value: '임금채권' },
  { name: 'NPL(부실채권)', value: 'NPL(부실채권)' },
  { name: '공시가격 1억 이하', value: '공시가격 1억 이하' },
  { name: '최근 2주 변동 물건', value: '최근 2주 변동 물건' },
  { name: '반값 경매물건', value: '반값 경매물건' },
  // { name: '반값 공매물건', value: '반값 공매물건' },
  { name: '반값 NPL물건', value: '반값 NPL물건' },
];
export const PtypeItemStatusData = [
  { name: '위반 건축물', value: '위반 건축물' },
  { name: '토지별도등기 있는 물건', value: '토지별도등기 있는 물건' },
  { name: '건물만 입찰 물건', value: '건물만 입찰 물건' },
  { name: '농지취득자격증명', value: '농지취득자격증명' },
  { name: '수의계약 가능물건', value: '수의계약 가능물건' },
];

export const PTypeRightStatusData = [
  { name: '유치권', value: '유치권' },
  { name: '법정지상권', value: '법정지상권' },
  { name: '분묘기지권', value: '분묘기지권' },
  { name: '선순위 가등기', value: '선순위 가등기' },
  { name: '선순위 가처분', value: '선순위 가처분' },
  { name: '지분입찰 물건', value: '지분입찰 물건' },
];

export const PTypeLesseeStatusData = [
  { name: '대항력있는 임차인', value: '대항력있는 임차인' },
];

export const RightStatusData = [
  { name: '유치권', value: '유치권' },
  { name: '유치권 배제', value: '유치권 배제' },
  { name: '법정지상권', value: '법정지상권' },
  { name: '분묘기지권', value: '분묘기지권' },
  { name: '선순위 가등기', value: '선순위 가등기' },
  { name: '선순위 가처분', value: '선순위 가처분' },
  { name: '지분입찰 물건', value: '지분입찰 물건' },
  { name: '예고등기', value: '예고등기' },
];
export const LesseeStatusData = [
  { name: '선순위 전세권/임차권', value: '선순위 전세권/임차권' },
  { name: '임차권 등기', value: '임차권 등기' },
  { name: '대항력있는 임차인', value: '대항력있는 임차인' },
  { name: '전세권만 매각', value: '전세권만 매각' },
  { name: 'HUG 임차권 인수조건 변경', value: 'HUG 임차권 인수조건 변경' },
];
export const FormalAuctionData = [
  { name: '유치권에의한 형식적경매', value: '유치권에의한 형식적경매' },
  { name: '기타 형식적경매', value: '기타 형식적경매' },
  {
    name: '공유물분할을  위한 형식적경매',
    value: '공유물분할을  위한 형식적경매',
  },
];

export const ResidentialAreaData = [
  { name: '제1종전용주거지역', value: '제1종전용주거지역' },
  { name: '제2종전용주거지역', value: '제2종전용주거지역' },
  { name: '제1종일반주거지역', value: '제1종일반주거지역' },
  { name: '제2종일반주거지역', value: '제2종일반주거지역' },
  { name: '제3종일반주거지역', value: '제3종일반주거지역' },
  { name: '준주거지역', value: '준주거지역' },
];

export const IndustrialAreaData = [
  { name: '전용공업지역', value: '전용공업지역' },
  { name: '일반공업지역', value: '일반공업지역' },
  { name: '준공업지역', value: '준공업지역' },
];
export const CommercialAreaData = [
  { name: '중심상업지역', value: '중심상업지역' },
  { name: '일반산업지역', value: '일반산업지역' },
  { name: '근린상업지역', value: '근린상업지역' },
  { name: '유통상업지역', value: '유통상업지역' },
];
export const GreenAreaData = [
  { name: '보전녹지지역', value: '보전녹지지역' },
  { name: '생산녹지지역', value: '생산녹지지역' },
  { name: '자연녹지지역', value: '자연녹지지역' },
];
export const ManagementAreaData = [
  { name: '계획관리지역', value: '계획관리지역' },
  { name: '생산관리지역', value: '생산관리지역' },
  { name: '보전관리지역', value: '보전관리지역' },
];
export const ExtractionAreaData = [
  { name: '농림지역', value: '농림지역' },
  { name: '자연환경보전지역', value: '자연환경보전지역' },
];
export const UseDistrictData = [
  { name: '경관지구', value: '경관지구' },
  { name: '고도지구', value: '고도지구' },
  { name: '방화지구', value: '방화지구' },
  { name: '방재지구', value: '방재지구' },
  { name: '보호지구', value: '보호지구' },
  { name: '취락지구', value: '취락지구' },
  { name: '개발진흥지구', value: '개발진흥지구' },
  { name: '특정용도제한지구', value: '특정용도제한지구' },
  { name: '복합용도지구', value: '복합용도지구' },
];
export const UseAreaData = [
  { name: '개발제한구역', value: '개발제한구역' },
  { name: '도시자연공원구역', value: '도시자연공원구역' },
  { name: '시가화조정구역', value: '시가화조정구역' },
  { name: '수산자원보호구역', value: '수산자원보호구역' },
  { name: '입지규제최소구역', value: '입지규제최소구역' },
];

export const KamcoAssetData = [
  { name: '압류재산', value: '압류재산' },
  { name: '국유재산', value: '국유재산' },
  { name: '수탁재산', value: '수탁재산' },
  { name: '유입자산', value: '유입자산' },
  { name: '수탁담보주택', value: '수탁담보주택' },
];

export const OrganAssetData = [
  { name: '국유재산', value: '국유재산' },
  { name: '공유재산', value: '공유재산' },
  { name: '기타일반재산', value: '기타일반재산' },
  { name: '금융권담보재산', value: '금융권담보재산' },
];

export const HoldingCompanyData = [
  { name: '전체', value: '전체' },
  { name: '연합자산관리', value: '연합자산관리' },
  { name: '대신FNI', value: '대신FNI' },
  { name: '키움FNI', value: '키움FNI' },
  { name: '우리금융FNI', value: '우리금융FNI' },
  { name: '하나FNI', value: '하나FNI' },
  { name: '저축은행', value: '저축은행' },
  { name: '자산관리', value: '자산관리' },
  { name: '대부업체', value: '대부업체' },
  { name: '신용정보', value: '신용정보' },
  { name: '이지스자산운용', value: '이지스자산운용' },
  { name: '농협자산관리', value: '농협자산관리' },
  { name: '농축협지점', value: '농축협지점' },
  { name: '충북농협', value: '충북농협' },
  { name: '수협', value: '수협' },
  { name: 'MG새마을금고', value: 'MG새마을금고' },
  { name: '기타', value: '기타' },
];

export const RatingData = [
  { value: '1', label: '★' },
  { value: '2', label: '★★' },
  { value: '3', label: '★★★' },
];

export const CommercialBankData = [
  { name: '신한은행', value: 'A010102' },
  { name: '우리은행', value: 'A010103' },
  { name: 'SC제일은행', value: 'A010104' },
  { name: 'KEB하나은행', value: 'A010105' },
  { name: '씨티은행', value: 'A010106' },
  { name: '국민은행', value: 'A010107' },
  { name: '아이엠뱅크', value: 'A010108' },
];

export const LocalBankData = [
  { name: '부산은행', value: 'A010202' },
  { name: '광주은행', value: 'A010203' },
  { name: '제주은행', value: 'A010204' },
  { name: '전북은행', value: 'A010205' },
  { name: '경남은행', value: 'A010206' },
];

export const InternetBankData = [
  { name: '케이뱅크', value: 'A010302' },
  { name: '카카오뱅크', value: 'A010303' },
  { name: '토스뱅크', value: 'A010304' },
];

export const SpecialBankData = [
  { name: '산업은행', value: 'A010402' },
  { name: '기업은행', value: 'A010403' },
  { name: '수출입은행', value: 'A010404' },
  { name: '농협은행', value: 'A010405' },
  { name: '수협은행', value: 'A010406' },
];
export const SecuritiesCompanyData = [
  { name: '증권사 전체', value: 'A020101' },
];

export const InsuranceCompanyData = [
  { name: '생명보험사 전체', value: 'A020202' },
  { name: '손해보험사 전체', value: 'A020203' },
];

export const SavingsBankData = [{ name: '저축은행 전체', value: 'A020301' }];

export const MutualFinanceData = [
  { name: '단위농축협', value: 'A020402' },
  { name: '단위수협', value: 'A020403' },
  { name: '신협', value: 'A020404' },
  { name: '산림조합', value: 'A020405' },
  { name: '새마을금고', value: 'A020406' },
];

export const CreditSpecializedCompanyData = [
  { name: '신용카드사 전체', value: 'A020502' },
  { name: '리스할부금융사 전체', value: 'A020503' },
  { name: '신기술금융사 전체', value: 'A020504' },
];

export const TrustCompanyData = [{ name: '신탁사 전체', value: 'A030101' }];
export const LoanCompanyData = [{ name: '대부업체 전체', value: 'A030201' }];
export const SecuritizationSpecializedCompanyData = [
  { name: '유동화전문유한회사 전체', value: 'A030301' },
];
export const OnlineInnvestmentFinancialBusiness = [
  { name: '온라인투자연계금융업 전체', value: 'A030401' },
];

export const NonghyupData = [
  { name: '농협은행', value: 'A040102' },
  { name: '농협자산관리', value: 'A040103' },
  { name: '농협경제지주', value: 'A040104' },
  { name: '농협생명보험', value: 'A040105' },
  { name: '농협중앙회', value: 'A040106' },
  { name: '엔에이치농협캐피탈', value: 'A040107' },
  { name: '단위농축협', value: 'A040108' },
];

export const KFCCData = [
  { name: '새마을금고', value: 'A050102' },
  { name: '새마을금고중앙회', value: 'A050103' },
  { name: '엠씨아이대부', value: 'A050104' },
];

export const SuhyupData = [
  { name: '수협은행', value: 'A060102' },
  { name: '단위수협', value: 'A060103' },
  { name: '수협중앙회', value: 'A060104' },
];

export const AuctionProcedureList = [
  {
    value: '임의/강제',
    label: '임의/강제',
  },
  {
    value: '임의경매',
    label: '임의경매',
  },
  {
    value: '강제경매',
    label: '강제경매',
  },
];
export const ExpectItemStatusList = [
  {
    value: '전체',
    label: '전체',
  },
  {
    value: '진행예정',
    label: '진행예정',
  },
  {
    value: '각하',
    label: '각하',
  },
  {
    value: '기각',
    label: '기각',
  },
  {
    value: '기타',
    label: '기타',
  },
  {
    value: '이송',
    label: '이송',
  },
  {
    value: '취소',
    label: '취소',
  },
  {
    value: '취하',
    label: '취하',
  },
  {
    value: '모사건종결',
    label: '모사건종결',
  },
];

export const PriceList = [
  {
    value: 'B',
    label: '~1천만원',
  },
  {
    value: 'C',
    label: '1~3천만원',
  },
  {
    value: 'D',
    label: '3~5천만원',
  },
  {
    value: 'E',
    label: '5천~1억원',
  },
  {
    value: 'F',
    label: '1~3억원',
  },
  {
    value: 'G',
    label: '3~5억원',
  },
  {
    value: 'H',
    label: '5~10억원',
  },
  {
    value: 'I',
    label: '10억원~',
  },
];

export const MapCategory = [
  { value: 'all', label: '전체' },
  { value: 'A2', label: '아파트' },
  { value: 'A5,A6', label: '단독/다가구' },
  { value: 'A4', label: '다세대/연립' },
  { value: 'A7', label: '빌딩/건물' },
  { value: 'B2', label: '상가' },
  { value: 'A3', label: '오피스텔' },
  { value: 'B1,B4', label: '공장/창고' },
  { value: 'A8', label: '숙박시설' },
  { value: 'A1', label: '토지' },
  // { value: 'C1', label: '기타' },
];

export const MapProgressStatusList = [
  { value: '', label: '' },
  { value: 'all', label: '전체' },
  { value: 'A', label: '진행' },
  { value: 'C', label: '예정' },
  { value: 'B', label: '매각' },
];

export const MapItemCategory = [
  { value: 'A1', label: '토지' },
  { value: 'A2', label: '아파트' },
  { value: 'A3', label: '오피스텔' },
  { value: 'A4', label: '빌라' },
  { value: 'A5', label: '단독' },
  { value: 'A6', label: '다가구' },
  { value: 'A7', label: '빌딩' },
  { value: 'B1', label: '공장' },
  { value: 'B2', label: '상가' },
  { value: 'B3', label: '주차장' },
  { value: 'B4', label: '창고' },
  { value: 'B5', label: '아파트형공장' },
  { value: 'C1', label: '기타' },
];
